import { Button, styled } from '@mui/material';
import { UploadButtonProps } from './types';

const VisuallyHiddenInput = styled('input')({
  bottom: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  left: 0,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1,
});

export const UploadButton: React.FC<UploadButtonProps> = ({
  buttonText,
  dataTestId,
  disabled,
  onChange,
  sx,
}) => {
  return (
    <Button
      disabled={disabled}
      component="label"
      data-testid={dataTestId}
      sx={sx}
      tabIndex={-1}
      variant="contained"
    >
      {buttonText}
      <VisuallyHiddenInput type="file" onChange={onChange} multiple />
    </Button>
  );
};
